import axios from 'axios';
import { toast } from 'react-toastify';
import { AppDispatch } from '../store';
import http from '../services/httpService';
import { getDetailedErrorMessage } from '../../utilities/errorHandler';

export const updateProfile =
  (profileData: any, onClose: () => void, navigate: (path: string) => void) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: 'PROFILE_UPDATE_REQUEST' });

    try {
      const response = await http.put('/profile', profileData);

      if (response.status === 201) {
        dispatch({
          type: 'PROFILE_UPDATE_SUCCESS',
          payload: response.data.data,
        });

        toast.success('Profile updated successfully!', {
          autoClose: 3000,
          pauseOnHover: false,
          onClose: () => {
            onClose();
            navigate('/profile');
          },
        });
      }
    } catch (error) {
      const errorMessage = getDetailedErrorMessage(error, 'Profile update failed. Please try again.');
      
      dispatch({
        type: 'UPDATE_PROFILE_FAILURE',
        payload: errorMessage,
      });
      
      console.error('Profile update error details:', error);
      toast.error(errorMessage);
    }
  };

export const updateProfilePicture =
  (file: File) => async (dispatch: AppDispatch) => {
    dispatch({ type: 'PROFILE_PICTURE_UPDATE_REQUEST' });

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await http.post('/profile/picture', formData);

      if (response.data.success) {
        dispatch({
          type: 'PROFILE_PICTURE_UPDATE_SUCCESS',
          payload: {
            path: response.data.data.path,
          },
        });
      } else {
        dispatch({
          type: 'PROFILE_PICTURE_UPDATE_FAILURE',
          payload: 'Failed to update profile picture.',
        });
      }
    } catch (error: any) {
      dispatch({
        type: 'PROFILE_PICTURE_UPDATE_FAILURE',
        payload: error.response?.data?.message || 'An error occurred.',
      });
    }
  };
